// src/models/caixas/CaixaResumo.js
export class CaixaResumo {
  constructor(
    id,
    caixaId,
    usuarioIdAber,
    abertura,
    valorAbertura = 0,
    valorEntrada = 0,
    valorSaida = 0,
    usuarioIdFecha,
    fechamento,
    valorFechamento,
    caixa,
    usuarioAber,
    usuarioFecha
  ) {
    this.id = id;
    this.caixaId = caixaId;
    this.usuarioIdAber = usuarioIdAber;
    this.abertura = abertura;
    this.valorAbertura = valorAbertura;
    this.valorEntrada = valorEntrada;
    this.valorSaida = valorSaida;
    this.usuarioIdFecha = usuarioIdFecha || null;
    this.fechamento = fechamento || null;
    this.valorFechamento = valorFechamento || null;
    this.caixa = caixa || null;
    this.usuarioAber = usuarioAber || null;
    this.usuarioFecha = usuarioFecha || null;
  }
}
